import React, { useState } from "react";
import { Box, IconButton, Collapse, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { ProductList } from "./ProductList";
import { PriceSummary } from "./PriceSummary";
import { CartItem } from "@ecommerce/store";
import { STYLES } from "../ShoppingCart/ShoppingCartStyles";

interface MobileOrderSummaryProps {
  cartItems: CartItem[];
  priceSummary: PriceSummary;
  hasSelectedShippingOption: boolean;
  onToggle: (isOpen: boolean) => void;
}

export const MobileOrderSummary: React.FC<MobileOrderSummaryProps> = ({ 
  cartItems, 
  priceSummary,
  hasSelectedShippingOption,
  onToggle
}) => {
  const [showOrderDetails, setShowOrderDetails] = useState(false);

  const toggleOrderDetails = () => {
    const newState = !showOrderDetails;
    setShowOrderDetails(newState);
    onToggle(newState);
  };

  return (
    <Box sx={{ 
      backgroundColor: 'white',
      boxShadow: showOrderDetails ? '0 2px 8px rgba(0,0,0,0.15)' : '0 2px 4px rgba(0,0,0,0.1)',
      transition: 'box-shadow 0.3s ease',
      position: 'relative',
      zIndex: 2,
    }}>
      <Box sx={{ p: 1 }}>
        <IconButton
          onClick={toggleOrderDetails}
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            textTransform: 'none',
            color: '#010101',
            p: 1,
            borderRadius: 0,
            '&:hover': { backgroundColor: 'transparent' }
          }}
          disableRipple
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {showOrderDetails ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            <Typography sx={{ 
              fontFamily: STYLES.fontFamily, 
              fontSize: '13px',
              color: '#010101',
            }}>
              {showOrderDetails ? 'Ocultar detalles' : 'Ver detalles de mi compra'}
            </Typography>
          </Box>
          <Typography sx={{ 
            fontFamily: STYLES.fontFamily, 
            fontSize: '16px',
            color: STYLES.colors.secondary,
            fontWeight: 'bold'
          }}>
            ${priceSummary.total.toLocaleString()}
          </Typography>
        </IconButton>
      </Box>
      
      <Collapse in={showOrderDetails}>
        <Box sx={{ 
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: 'white',
        }}>
          <Box sx={{ 
            flex: 1,
            overflow: 'auto',
            maxHeight: '200px',
          }}>
            <Box sx={{ p: 2 }}>
              <ProductList cartItems={cartItems} />
            </Box>
          </Box>
          
          <Box sx={{ 
            flexShrink: 0,
            borderTop: '1px solid #e0e0e0',
            backgroundColor: 'white',
          }}>
            <Box sx={{ p: 2 }}>
              <PriceSummary summary={priceSummary} hasSelectedShippingOption={hasSelectedShippingOption} />
            </Box>
          </Box>
        </Box>
      </Collapse>
    </Box>
  );
};














